import React from "react";
import Chart from "react-google-charts";
import Loader from "../../Utils/Loader";
import Empty from "./Empty";
import classes from "./styles.module.css";
import useIsMobile from "../../../hooks/useIsMobile";

function CountryChart({data}) {
    const isMobile = useIsMobile();

    const normalized = React.useMemo(() => {
        if (!Array.isArray(data) || data.length <= 1) return []; // нет строк данных

        const header = data[0] || [];
        const rows = data.slice(1);


        if (header.length >= 3) {
            return [
                ["Country", "Value", {role: "tooltip", type: "string"}],
                ...rows.map((r) => {
                    const country = String(r[0]);
                    const value = Number(r[1]);               // чем красим карту
                    // что показать в подсказке
                    return [country, value, `Transactions: ${r[1]}\nSUM: ${r[2]}`];
                }),
            ];
        }

        // только две колонки
        return [
            ["Country", "Value"],
            ...rows.map((r) => [String(r[0]), Number(r[1])]),
        ];
    }, [data]);

    if (normalized.length <= 1) return <Empty/>;

    return (
        <div className={classes.Wrap}>
            <div className={classes.Chart}>
                <Chart
                    width={"100%"}
                    height={isMobile ? "230px" : "350px"}
                    chartType="GeoChart"
                    loader={<Loader/>}
                    data={normalized}
                    options={{
                        colorAxis: {colors: ["#86a2c1", "#273246"]},
                    }}
                />
            </div>
        </div>
    );
}

export default CountryChart;



// WEBPACK FOOTER //
// ./src/Components/Charts/CountryChart/index.js